t = require('app/scripts/views/internal/teacup-with-helpers')('member_on_board_menu')
{ featureFlagClient } = require '@trello/feature-flag-client'
{ dontUpsell } = require '@trello/config'

module.exports = ->
  t.li ->
    if t.mustacheVar 'canInviteMemberToTeam'
      auaaPhase2FlagEnabled = featureFlagClient.get('btg.all-users-are-admins.phase-2', false)
      isFreeTeam = t.mustacheVar('isFreeTeam')
      allAdminsEnabled = t.mustacheVar('allAdminsEnabled')
      link = if dontUpsell then '/business-class' else t.mustacheVar('orgBillingUrl')
      if auaaPhase2FlagEnabled && isFreeTeam && allAdminsEnabled
        t.div { class: 'js-add-to-team pop-over-list-item', role: 'button', tabIndex: "0" }, ->
          t.format 'add-to-team-as-admin'
          t.small '.add-to-team-upgrade-bc', ->
            t.format 'for-more-roles', { link }
      else
        t.a { class: 'js-add-to-team', href: '#' }, ->
          t.format 'add-to-team'
    t.mustacheBlock 'type', ->
      t.a { class: t.mustacheBlock('canChangeRole', (-> 'js-change-role')) + t.mustacheBlockInverted('canChangeRole', (-> 'disabled')), href: '#' }, ->
        t.format 'change-permissions-ellipsis-type', { type: t.mustacheVar('type') }
    t.mustacheBlockInverted 'type', ->
      t.a { class: t.mustacheBlock('canChangeRole', (-> 'js-change-role')) + t.mustacheBlockInverted('canChangeRole', (-> 'disabled')), href: '#' }, ->
        t.format 'change-permissions-ellipsis'

  if !t.mustacheVar 'isTemplate'
    t.li ->
      t.a { class: 'js-view-member-activity', href: t.mustacheVar('boardProfileUrl') }, ->
        t.format 'view-member-s-board-activity'

  t.mustacheBlock 'canRemove', ->
    t.li ->
      t.a '.js-remove-member', ->
        t.mustacheBlock 'isMe', ->
          t.format 'leave-board-ellipsis'
        t.mustacheBlockInverted 'isMe', ->
          t.format 'remove-from-board-ellipsis'

  t.mustacheBlockInverted 'canRemove', ->
    t.mustacheBlock 'isMe', ->
      t.mustacheBlock 'isMoreThanOneMember', ->
        t.mustacheBlock 'memberIsAdmin', ->
          t.li ->
            t.hr()
            t.p '.quiet.u-bottom', ->
              t.format 'you-can-t-leave-because-you-are-the-only-admin-to-make-another-user-an-admin-click-their-avatar-select-change-permissions-ellipsis-and-select-admin'

  t.mustacheBlock 'isGhost', ->
    t.li ->
      t.hr()
      t.p '.quiet.u-bottom', ->
        t.format 'this-user-will-be-able-to-access-this-board-once-they-sign-up-with-trello-and-confirm-their-email-address'
